// Service de gestion des abonnements
import { apiFetch } from './httpClient';

export type SubscriptionType = 'standard' | 'premium';

export interface PremiumInterestPayload {
  context: string;
  devisId?: string;
  articleId?: string;
  answers: Record<string, unknown>;
  meta?: Record<string, unknown>;
}

/**
 * Service pour gérer les abonnements utilisateur
 */
class SubscriptionService {
  private authUser: { subscriptionType?: SubscriptionType } | null = null;

  setAuthUser(user: { subscriptionType?: SubscriptionType } | null) {
    this.authUser = user;
    if (user?.subscriptionType) {
      localStorage.setItem('lastSubscriptionType', user.subscriptionType);
    }
  }

  /**
   * Récupère le type d'abonnement de l'utilisateur actuel
   */
  getSubscriptionType(): SubscriptionType {
    if (this.authUser?.subscriptionType) {
      return this.authUser.subscriptionType;
    }

    const storedType = localStorage.getItem('subscriptionType') || localStorage.getItem('lastSubscriptionType');
    return (storedType as SubscriptionType) === 'premium' ? 'premium' : 'standard';
  }

  /**
   * Vérifie si l'utilisateur a accès aux fonctionnalités premium
   */
  hasPremiumFeatures(): boolean {
    return this.getSubscriptionType() === 'premium';
  }

  /**
   * Simule une demande de contact pour un abonnement premium
   */
  async requestPremiumContact(name: string, email: string, phone: string): Promise<boolean> {
    console.log(`Demande d'abonnement premium reçue de ${name} (${email}, ${phone})`);

    await new Promise(resolve => setTimeout(resolve, 1000));
    return true;
  }

  /**
   * Journalise un intérêt pour le Premium côté backend.
   */
  async sendPremiumInterest(payload: PremiumInterestPayload): Promise<boolean> {
    await apiFetch('/premium/interest', {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return true;
  }
}

export const subscriptionService = new SubscriptionService();

